import React, { Component } from "react";

import "./skeleton.css";
class SkeletonTitle extends Component {
  render() {
    return <h3 className="loading__title">Loading...</h3>;
  }
}

export default SkeletonTitle;



// WEBPACK FOOTER //
// ./src/components/skeleton/SkeletonTitle.js